import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=6212f40a&scoped=true&"
import script from "./TagsList.vue?vue&type=script&lang=ts&"
export * from "./TagsList.vue?vue&type=script&lang=ts&"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=6212f40a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212f40a",
  null
  
)

export default component.exports